"use client";
const no = {
  components: {
    feedback: {
      alerts: {
        dismissLabel: "Lukk"
      }
    },
    surfaces: {
      modal: {
        dismissLabel: "Lukk"
      }
    },
    inputs: {
      pickers: {
        calendar: {
          calendar: "Kalender",
          showPreviousMonth: "Vis forrige måned",
          showNextMonth: "Vis neste måned",
          shortDayNames: {
            mon: "Man",
            tue: "Tir",
            wed: "Ons",
            thu: "Tor",
            fri: "Fre",
            sat: "Lør",
            sun: "Søn"
          },
          monthNames: {
            1: "Januar",
            2: "Februar",
            3: "Mars",
            4: "April",
            5: "Mai",
            6: "Juni",
            7: "Juli",
            8: "August",
            9: "September",
            10: "Oktober",
            11: "November",
            12: "Desember"
          }
        }
      }
    }
  },
  validation: {
    defaultRequiredError: "Vennligst fyll ut dette feltet.",
    required: "Må fylles ut",
    optional: "Valgfritt",
    characters: "tegn",
    digits: "siffer",
    errors: {
      invalidCharacters: "Inneholder ugyldige tegn.",
      onlyDigits: "Kan kun inneholde siffer.",
      invalidEmail: "Ugyldig e-postadresse.",
      invalidName: "Ugyldig navn.",
      invalidNameRegex: "Kan kun inneholde bokstaver, mellomrom, apostrof og bindestrek.",
      invalidPhoneNumber: "Ugyldig telefonnummer.",
      invalidCellPhoneFirstDigit: "Må starte med 4 eller 9.",
      invalidRegistrationNumber: "Må bestå av 2 bokstaver og 5 siffer. Eksempel: AB12345",
      invalidLength: (length, characterType) => `Må bestå av ${length} ${characterType}.`,
      invalidMaxLength: (maxLength, characterType) => `Kan ikke være mer enn ${maxLength} ${characterType}.`
    }
  },
  form: {
    fieldNecessityPreamble: {
      allFieldsRequired: "Alle felter må fylles ut.",
      allFieldsOptional: "Alle felter er valgfri.",
      allFieldsRequiredUnless: "Alle felter må fylles ut med mindre noe annet er spesifisert.",
      allFieldsOptionalUnless: "Alle felter er valgfri med mindre noe annet er spesifisert."
    }
  }
};
export {
  no
};
